import React, {useEffect, useState} from "react";
import t from "../components/I18N/TranslateHelpers";
import {GetCurrentLocale, pathname, injectHtmlMetaTag} from "../components/Utils";
import {LocalParams} from "./LocalParams";
import {FIN_STOCK_CODE, INDIVIDUAL_PROTECTION_CODE} from "../app/AppConfig";
import {ProductTranslation} from "../features/Entity/Product";
interface ComponentProps {
  catalogueName: any
  filters: any,
  productName?: string
  isforProductDetail: boolean,
  productmetaKeywords: string
  productmetaDescription : string,
}

const PageTitle = ({catalogueName, filters, productName, isforProductDetail, productmetaKeywords, productmetaDescription}: ComponentProps) => {
  const locale = GetCurrentLocale();
  const filtersSelectedBefore = LocalParams.getItem('filtersSelected');
  // useEffect(() => {
  //     changeLanguage(locale);
  //     if(!filters)
  //     {
  //       dispatch(getProductsFilters(locale));
  //     }
  //   }, []
  // );

  //on va sortir le filtre qui correspond à celui sélectionné pour récupérer le label et le groupLabel
  const currentCatalogue = filters?.filter((a: any) => a.code === catalogueName);
  const [catalogueEPI, setCatalogueEPI] = useState(false)

  React.useEffect(() => {
      if(productName){
        injectHtmlMetaTag(productName, productmetaDescription, productmetaKeywords)
      }
    }, []
  );

  // on récupère la sélection de produits dans le local storage
  // on le parse et on le met dans un array
  let productsInSelection: string = LocalParams.getItem('productsSelection')  ?? "";
  let productsSelection;
  try {
    productsSelection = JSON.parse(productsInSelection);
  } catch (error) {
    productsSelection = [];
  }
  let allSlugInSelect: string[] = [];
  productsSelection &&  productsSelection.items && productsSelection.items.map((productSelection: any) => {
    allSlugInSelect.push(productSelection.slug);
  })
  // get du slug courant pour trouver son index dans le tableau
  let currentProductSlug = pathname.split('/')[3];
  let currentProduct = allSlugInSelect.findIndex(a => a === currentProductSlug);
  const [isCatalogEndOfStock, setIsCatalogEndOfStock] = useState(false);
  useEffect(() => {
    const url = window.location.href;
    const params = new URLSearchParams(url.split('?')[1]);
    const individualProtection = INDIVIDUAL_PROTECTION_CODE && params.get(INDIVIDUAL_PROTECTION_CODE);
    if(catalogueName == FIN_STOCK_CODE){
      setIsCatalogEndOfStock(true)
    }else{
      setIsCatalogEndOfStock(false)
    }
    if(individualProtection){
      setCatalogueEPI(true)
    }
  }, [catalogueName]);
  const [nextProduct, setNextProduct] = useState(currentProduct + 1);
  const [prevProduct, setPrevProduct] = useState(currentProduct - 1);

  let nextProductSlug = allSlugInSelect[nextProduct];
  let prevProductSlug = allSlugInSelect[prevProduct];

  const goToNextProduct = () => {
    window.location.href = nextProductSlug;
  }

  const goToPrevProduct = () => {
    window.location.href = prevProductSlug;
  }

  const breadCrumb = (isProductDetail: boolean) => {
    return(
      <ol className="breadcrumb ondark mb-0">
        <li className="breadcrumb-item"><a href={"/" + locale }>{t('home')}</a></li>
        <li className="breadcrumb-item"><a href={"/" + locale + "/" + t('url_catalogue')}>{ t('products')}</a></li>
        {
          !isProductDetail && catalogueName !== "" &&  (currentCatalogue.length > 0 && currentCatalogue[0] !== undefined) ?
            <li className="breadcrumb-item active" aria-current="page">{ currentCatalogue[0].groupLabel } / { currentCatalogue[0].label }</li>
            :
            productName !== undefined ?
              <li className="breadcrumb-item active" aria-current="page">{ productName }</li>
              : null
        }
      </ol>
    )
  }

  const goBackToCatalogueFiltered = () => {
    if(filtersSelectedBefore){
      window.location.href = "/" + locale + "/" + t('url_catalogue') + filtersSelectedBefore.replaceAll('\"', '')
    }
  }

  return (
    <>
      {
        // titre pour le catalogue
        !isforProductDetail && currentCatalogue ?
          <section className="bg-primary padding-y heading-page bg-header">
            <div className="container d-flex justify-content-between align-items-center">
              <header className="section-heading">
                {
                  (catalogueName !== "" || (currentCatalogue && currentCatalogue.length > 0 && currentCatalogue[0])) ?
                    <h3 className="section-title h1">{
                      t('catalogue') } { isCatalogEndOfStock ? <span>{t('end_of_stock')} <br/></span>  : null }
                      { currentCatalogue && currentCatalogue.length > 0 ? currentCatalogue[0].label : '' }
                    </h3>
                    :
                    <h3 className="section-title h1">{t('catalogue') } </h3>
                }
              </header>
              { breadCrumb(false )}
            </div>
          </section>
          :
          null
      }
      {
        // titre pour le titre du produit
        isforProductDetail ?
          <section className="bg-primary padding-y heading-page bg-header">
            <div className="container d-flex justify-content-between align-items-center">
              { breadCrumb(true )}
              <div className="col-auto d-flex ">
                <button className="btn btn-light-outline nopadding py-2 px-2 noborderradiusright" onClick={() => goBackToCatalogueFiltered()}>
                  <i className="FA fa-solid fa-angle-left"></i> { t('back_to_selection')}
                </button>

                {(prevProductSlug !== undefined || nextProductSlug !== undefined) && (
                  <header className="btn-selection d-flex align-items-center justify-content-end btn btn-light-outline nopadding py-2 px-2 noborderradiusleft noborderleft">
                    <div className="btn-group">
                      {prevProductSlug !== undefined && (
                        <button onClick={() => goToPrevProduct()} className="btn-transparent" data-bs-toggle="tooltip" title="" data-bs-original-title="View prev selection">
                          <i className="fa fa-chevron-left"></i>
                        </button>
                      )}
                      {nextProductSlug !== undefined && (
                        <button onClick={() => goToNextProduct()} className="px-2 btn-transparent" data-bs-toggle="tooltip" title="" data-bs-original-title="View next selection">
                          <i className="fa fa-chevron-right"></i>
                        </button>
                      )}
                    </div>
                  </header>
                )}
              </div>
            </div>
          </section>
          : null
      }
    </>
  )
}

export default PageTitle;
